// Mirror of backend policy in api/src/AveOrga.Core/Services/PasswordPolicy.cs —
// keep both in sync. Backend is the authoritative check; this util only provides
// fast client-side feedback before the request.

export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_REQUIREMENTS_TEXT =
  "Mindestens 8 Zeichen, je ein Groß- und Kleinbuchstabe sowie eine Zahl.";

/**
 * Returns null if the password satisfies the policy, otherwise a German
 * error message describing the first violated rule.
 */
export function validatePassword(pw) {
  if (!pw || pw.length < PASSWORD_MIN_LENGTH)
    return `Das Passwort muss mindestens ${PASSWORD_MIN_LENGTH} Zeichen lang sein.`;
  if (!/[A-Z]/.test(pw))
    return "Das Passwort muss mindestens einen Großbuchstaben enthalten.";
  if (!/[a-z]/.test(pw))
    return "Das Passwort muss mindestens einen Kleinbuchstaben enthalten.";
  if (!/\d/.test(pw))
    return "Das Passwort muss mindestens eine Zahl enthalten.";
  return null;
}

/**
 * Validates a password change. Pass oldPassword to also check that the new
 * password differs from the old one. Returns a German error string or null.
 */
export function validatePasswordChange(newPassword, repeatPassword, oldPassword = null) {
  if (oldPassword !== null && newPassword === oldPassword)
    return 'Bitte wähle ein neues Passwort.';
  if (newPassword !== repeatPassword)
    return 'Die 2 Passwortfelder stimmen nicht überein.';
  return validatePassword(newPassword);
}
